import { handleActions, createAction } from 'redux-actions';

export const FETCH_CHANNELS = createAction('FETCH/CHANNELS');
export const FETCH_CHANNELS_SUCCESS = createAction('FETCH/CHANNELS/SUCCESS');
export const FETCH_CHANNELS_FAIL = createAction('FETCH/CHANNELS/FAIL');

const initialState = {
  fetchChannelsErrors: null,
};

const channelsReducer = handleActions(
  {
    [FETCH_CHANNELS_SUCCESS]: (state, { payload: { channels, }, }) => {
      return { ...state, channels, };
    },
    [FETCH_CHANNELS_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, fetchChannelsErrors: error, };
    },
  },
  initialState
);

export default channelsReducer;
